import PageTitle from "../Helpers/PageTitle";
import Layout from "../Partials/Layout";
import { useEffect } from "react";

export default function ReturnRefundPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Layout childrenClasses="pt-0 pb-0">
      <div className="terms-condition-page w-full bg-white pb-[30px]">
        <div className="w-full mb-[30px]">
          <PageTitle
            breadcrumb={[
              { name: "home", path: "/" },
              {
                name: "Return and Refund Policy",
                path: "/retun-refund-policy",
              },
            ]}
            title="Return and Refund Policy"
          />
        </div>
        <div className="w-full">
          <div className="container-x mx-auto">
            <div className="content-item w-full mb-10">
              <h2 className="text-[18px] font-medium text-qblack mb-4">
                Last updated: January 08, 2024
              </h2>
              <h2 className="text-[22px] font-medium text-qblack mb-5">
                Thank you for shopping at Items.lk
              </h2>
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                We value your satisfaction and strive to provide you with the
                best online shopping experience possible. If, for any reason,
                you are not completely satisfied with your purchase, we are here
                to help.
              </p>
            </div>

            <div className="content-item w-full mb-10">
              <h2 className="text-[18px] font-medium text-qblack mb-4">
                Returns
              </h2>
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                We accept returns within 7 days from the date of purchase. To be
                eligible for a return, your item must be unused and in the same
                condition that you received it. It must also be in the original
                packaging.
              </p>
            </div>

            <div className="content-item w-full mb-10">
              <h2 className="text-[18px] font-medium text-qblack mb-4">
                Refunds
              </h2>
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                Once we receive your return and inspect the item, we will notify
                you of the status of your refund. If your return is approved, we
                will initiate a refund to your original method of payment or
                bank transfer. Please note that the refund amount will exclude
                any shipping charges incurred during the initial purchase.
              </p>
            </div>

            <div className="content-item w-full mb-10">
              <h2 className="text-[18px] font-medium text-qblack mb-4">
                Exchanges
              </h2>
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                If you would like to exchange your item for a different size,
                color, or style, please contact our customer support team within
                48 hours of receiving your order. We will provide you with
                further instructions on how to proceed with the exchange.
              </p>
            </div>

            <div className="content-item w-full mb-10">
              <h2 className="text-[18px] font-medium text-qblack mb-4">
                Non-Returnable Items
              </h2>
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                The following items are non-returnable and non-refundable:
              </p>
              <ul className="list-disc ml-5 mb-5">
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  Items that are not physically damaged or defective
                </li>
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  Items that have been used or are not in original condition
                </li>
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  Items that are not in their original packaging
                </li>
              </ul>
            </div>

            <div className="content-item w-full mb-10">
              <h2 className="text-[18px] font-medium text-qblack mb-4">
                Return Shipping
              </h2>
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                We do not provide shipping labels. You will need to contact us
                for shipping instructions. You will be responsible for the
                shipping costs unless the return is due to our error (e.g.,
                wrong item shipped, defective product).
              </p>
            </div>

            <div className="content-item w-full mb-10">
              <h2 className="text-[18px] font-medium text-qblack mb-4">
                Processing Time
              </h2>
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                Refunds and exchanges will be processed within 7 business days
                after we receive your returned item. Please note that it may
                take additional time for the refund to appear in your account,
                depending on your payment provider.
              </p>
            </div>

            <div className="content-item w-full mb-10">
              <h2 className="text-[18px] font-medium text-qblack mb-4">
                Contact Us
              </h2>
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                If you have any questions or concerns regarding our refund
                policy, please contact our customer support team:
              </p>
              <ul className="list-disc ml-5 mb-5">
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  By email: info@items.lk
                </li>
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  By visiting this page on our website: www.items.lk
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
